import { incYenOf, incOf } from '../lib/pricing';
export const seminarOverview = {
  name: '体験講座「執事の作法・入門」',
  nameEn: 'ONE-DAY SEMINAR',
  duration: '1日',
  totalHours: '6時間（90分×4コマ）',
  price: incYenOf('ac-trial'),
  capacity: '定員6名（完全少人数制）',
  location: '本校（東京・お台場）',
  target: '執事・バトラーの仕事に興味がある方、本科の受講を検討中の方、上質な接遇を学びたい社会人',
  schedule: '開催日程は<a href="/news" class="text-accent-600 hover:text-accent-500 underline underline-offset-2 transition-colors">お知らせページ</a>で随時ご案内します',
};

export const trustBadges = [
  {
    icon: 'ri-time-line',
    text: '1日完結・6時間',
  },
  {
    icon: 'ri-exchange-funds-line',
    text: '参加費は本科受講料に全額充当',
  },
  {
    icon: 'ri-user-star-line',
    text: '本科と同じ講師が担当',
  },
];

export const programTimeline = [
  {
    time: '1限（10:00 – 11:30）',
    title: '執事という職業',
    titleEn: 'The Butler Profession',
    description: '執事という職業の歴史的背景から、個人邸宅・ホテル・企業といった現代における活躍の場まで、キャリアの実際を本科と同じ講師が講義します。海外と日本における執事像の違いや、これからの執事に求められる資質についてもお話しします。',
    imageSeq: 'seminar-period1',
  },
  {
    time: '2限（11:45 – 13:15）',
    title: '執事の所作',
    titleEn: 'Butler Comportment',
    description: '立ち姿・歩き方・ドアサービス・物の受け渡しといった基本所作を、白手袋を着けて一つずつ練習します。鏡を使った自己チェックと講師による個別指導で、見学ではなく実際に体を動かしながら執事の所作を体験いただきます。',
    imageSeq: 'seminar-period2',
  },
  {
    time: '3限（14:00 – 15:30）',
    title: 'ティーサービス実習',
    titleEn: 'Tea Service Practice',
    description: '茶葉の基礎知識、温度と蒸らし時間の管理、美しい注ぎ方までを一人ずつ実習します。受講生同士でサービスし合うロールプレイングを通じて、実際に紅茶を淹れて提供する一連の流れを体験いただきます。本格的な茶器を使った実習は体験講座ならではの内容です。',
    imageSeq: 'seminar-period3',
  },
  {
    time: '4限（15:45 – 17:15）',
    title: 'テーブルセッティング基礎と質疑応答',
    titleEn: 'Table Setting & Consultation',
    description: '朝食セッティングの基本を体験した後、本科3コースの違いとそれぞれの特徴をご説明します。その後、質疑応答と希望者への個別相談の時間を設け、あなたに最適な学びのステップを一緒に考えます。',
    imageSeq: 'seminar-period4',
  },
];

export const gainItems = [
  {
    icon: 'ri-building-2-line',
    title: '本物の執事教育の空気を肌で感じられる',
    description: '本科と同じ講師・同じ教室で学ぶことで、アカデミーの雰囲気や教育の質を実際に体感いただけます。入学後のミスマッチを防ぐ最良の機会です。',
  },
  {
    icon: 'ri-chat-3-line',
    title: '講師に直接キャリア相談ができる',
    description: '4限の個別相談では、あなたの目標やご経験に合わせたキャリアプランを講師と一緒に考えます。本科受講後の具体的な進路イメージを描くことができます。',
  },
  {
    icon: 'ri-file-list-3-line',
    title: '本科3コースの違いと自分に合う課程がわかる',
    description: 'エッセンシャル・アドバンス・マスターの違いや、未経験からプロまでの標準的な学習ステップを具体的に理解でき、最適なコース選びが可能になります。',
  },
  {
    icon: 'ri-hand-sanitizer-line',
    title: '白手袋を着けてのサービス体験',
    description: '執事の象徴である白手袋を実際に着用し、ティーサービスや所作の練習を行います。本科受講をより具体的にイメージできる実践的な体験です。',
  },
];

export const mainCourses = [
  {
    name: 'エッセンシャルコース',
    nameEn: 'ESSENTIAL COURSE',
    duration: '1ヶ月・8日間・48時間',
    price: incYenOf('ac-essential'),
    description: '基礎から始める入門課程。テーブルマナーから基本的なサービススキルまで、執事の土台を体系的に固めます。',
    href: '/courses/essential',
  },
  {
    name: 'アドバンスコース',
    nameEn: 'ADVANCED COURSE',
    duration: '2ヶ月・12日間・72時間',
    price: incYenOf('ac-advanced'),
    description: '専門技能を磨く中級課程。ワインサービスやイベント運営まで、より高度なホスピタリティを習得します。',
    href: '/courses/advanced',
  },
  {
    name: 'マスターコース',
    nameEn: 'MASTER COURSE',
    duration: '3ヶ月・16日間・96時間',
    price: incYenOf('ac-master'),
    description: 'プロを目指す最上級課程。管理能力からリーダーシップまで、執事長としての全領域を網羅します。',
    href: '/courses/master',
  },
];

export const relatedPages = [
  {
    title: 'コース一覧',
    description: '3つの本科コースを見る',
    href: '/courses',
  },
  {
    title: '入学案内',
    description: 'お申込みまでの流れ',
    href: '/admission',
  },
  {
    title: 'よくある質問',
    description: '受講に関する疑問にお答えします',
    href: '/faq',
  },
  {
    title: 'アクセス',
    description: '東京・お台場の校舎へのご案内',
    href: '/access',
  },
];

export const faqItems = [
  {
    question: 'まったくの未経験ですが大丈夫ですか？',
    answer: 'はい。体験講座は未経験の方のための入門プログラムです。道具と白手袋は当日お貸ししますので、筆記用具のみお持ちください。',
  },
  {
    question: '参加費の本科充当に期限はありますか？',
    answer: '体験講座ご参加から1年以内の本科お申込みを対象とする予定です。詳細はお申込み時のご案内に従ってください。',
  },
  {
    question: '服装の指定はありますか？',
    answer: '動きやすい綺麗めの服装（襟付きシャツ推奨）でお越しください。ジャケットの着用は任意です。',
  },
];